
interface Props {
  name: string;
  activeCount: number;
  active: boolean;
}
const __sfc_main = {};
__sfc_main.props = {
  name: {
    key: "name",
    required: true,
    type: String
  },
  activeCount: {
    key: "activeCount",
    required: false,
    type: Number,
    default: 0
  },
  active: {
    key: "active",
    required: false,
    type: Boolean,
    default: false
  }
};
__sfc_main.setup = (__props, __ctx) => {
  const props = __props;
  const emit = __ctx.emit;
  function onClick() {
    !props.active && emit('click');
  }
  return {
    onClick
  };
};
export default __sfc_main;
